import React from 'react'
import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import NoIntegration from '../../svgs/NoIntegration'

const NoConfiguredIntegration = () => {
  const { t } = useTranslation('NoConfiguredIntegration')

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{ minHeight: '60vh' }}
      id="no-integration"
    >
      <div className="mb-4">
        <NoIntegration size={10} />
      </div>
      <h4 className="mb-3">{t('title')}</h4>
      <p className="text-muted mb-4" style={{ maxWidth: '400px' }}>
        {t('message')}
      </p>
      <Button color="primary" tag={Link} to="/settings">
        {t('goToSettings')}
      </Button>
    </div>
  )
}

export default NoConfiguredIntegration
